/**
 * API asignaciones auxiliar ↔ cliente operativo — /api/despacho/assignments.
 */
import api from "@/lib/api";
import { DESPACHO_ASSIGNMENTS_FORBIDDEN_MESSAGE } from "@/modules/despacho/despachoPermissions";

export const DESPACHO_ASSIGNMENTS_API_PATH = "/despacho/assignments";

export function parseDespachoAssignmentsError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  const detailMessage = typeof detail === "string"
    ? detail
    : (typeof detail === "object" && detail?.message ? String(detail.message) : "");
  const code = typeof detail === "object" && detail?.code ? detail.code : "";

  if (status === 403) {
    if (code === "DESPACHO_ASSIGNMENTS_FORBIDDEN") {
      return { kind: "assignments_forbidden", message: DESPACHO_ASSIGNMENTS_FORBIDDEN_MESSAGE };
    }
    return { kind: "forbidden", message: DESPACHO_ASSIGNMENTS_FORBIDDEN_MESSAGE };
  }

  if (status === 404) {
    return {
      kind: "not_found",
      message: detailMessage || "Cliente o usuario interno no encontrado.",
    };
  }

  if (status === 409) {
    if (code === "CLIENT_OPERATIVO_SUSPENDIDO") {
      return {
        kind: "suspended",
        message: detailMessage
          || "El cliente está suspendido; reanudarlo antes de asignar auxiliares.",
      };
    }
    if (code === "DESPACHO_SHADOW_CONFLICT") {
      return {
        kind: "shadow_conflict",
        message: detailMessage
          || "Conflicto al vincular la empresa (RFC duplicado en catálogo operativo).",
      };
    }
    return {
      kind: "conflict",
      message: detailMessage || "No se pudo guardar la asignación (conflicto).",
    };
  }

  if (status === 400) {
    return {
      kind: "validation",
      message: detailMessage || "Datos de asignación inválidos.",
    };
  }

  if (status === 500 || status === 502 || status === 503) {
    return {
      kind: "server",
      message: detailMessage || "Error del servidor al guardar la asignación. Intente de nuevo.",
    };
  }

  if (!status && (err?.code === "ECONNABORTED" || /timeout/i.test(String(err?.message || "")))) {
    return {
      kind: "timeout",
      message: "La asignación tardó demasiado. Revise la conexión e intente de nuevo.",
    };
  }

  return {
    kind: "error",
    message: detailMessage || "No pudimos guardar las asignaciones.",
  };
}

export function createDespachoAssignmentsApi(httpClient = api) {
  return {
    async list(params = {}) {
      const { data } = await httpClient.get(DESPACHO_ASSIGNMENTS_API_PATH, { params });
      return Array.isArray(data?.items) ? data.items : [];
    },

    async replaceForClient(clientId, assignments) {
      const { data } = await httpClient.put(`/despacho/clients/${clientId}/assignments`, {
        assignments,
      });
      return data;
    },
  };
}

export const despachoAssignmentsApi = createDespachoAssignmentsApi();
